import initialState from './ChainInitialState';
import reducers from './ChainReducer';

export default {
  initialState,
  reducers,
};
